import { z } from 'zod'

export const archiveDocumentSchema = z.object({
  archiveReason: z
    .string()
    .max(500, 'Reason must be at most 500 characters')
    .optional(),
})

export type ArchiveDocumentFormData = z.infer<typeof archiveDocumentSchema>
